export default __webpack_public_path__ + "static/media/TeacherLandingWhite.8d75f2cb.svg";